import { TypedDocumentNode } from '@apollo/client';
import { useMutation } from '@apollo/client/react';
import { Mutation, MutationOnboardingChooseProviderArgs, Provider } from 'graphql/generated/graphqlTypes';
import { CHOOSE_PROVIDER } from 'graphql/mutations';
import { GET_CURRENT_TENANT } from 'graphql/queries';
import { BaseHookProps } from 'hooks/shared/types';
import { useEffect } from 'react';
import { ignoreHandledMutationError } from 'utils/Mutation/ignoreHandledMutationError';

// Typing the documents (instead of passing generics to the Apollo hooks) avoids the deprecated hook signatures.
const CHOOSE_PROVIDER_TYPED: TypedDocumentNode<
  Pick<Mutation, 'onboardingChooseProvider'>,
  MutationOnboardingChooseProviderArgs
> = CHOOSE_PROVIDER;

const useChooseProvider = ({ handleFetchError }: BaseHookProps) => {
  const [chooseProviderMutation, { loading, error }] = useMutation(CHOOSE_PROVIDER_TYPED, {
    refetchQueries: [{ query: GET_CURRENT_TENANT }],
    awaitRefetchQueries: true
  });

  useEffect(() => {
    if (error) {
      handleFetchError('Error while choosing provider');
      console.error(error);
    }
  }, [error]);

  const chooseProvider = async (provider: Provider) => {
    // Failure is already reported through the hook's `error` state, so the rejection is ignored here.
    await ignoreHandledMutationError(
      chooseProviderMutation({
        variables: {
          provider
        }
      })
    );
  };

  return {
    loading,
    chooseProvider
  };
};

export default useChooseProvider;
